module.exports = __webpack_public_path__ + "static/img/decoration.8db747d9.png";